import React from 'react';
import {Helmet} from 'react-helmet';
import { useLocation } from '@reach/router';

export const Metatags = (props: {
  siteTitle: string;
  descriptionTitle: string;
  description: string;
  image: string;
  url: string;
}): JSX.Element => {

  const { pathname } = useLocation();
  const url = `${props.url}${pathname}`;

  return (
    <Helmet>
      <title>{props.siteTitle}</title>
      <meta name="title" content={props.descriptionTitle} />
      <meta name="description" content={props.description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={props.descriptionTitle} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" itemProp="image primaryImageOfPage" content={props.image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={props.descriptionTitle} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={props.image} />
    </Helmet>
  );
};
